import { alpha, Box, Typography } from "@mui/material";

export const OrphanBadge = ({
	badgeRef,
}: {
	badgeRef?: React.RefObject<HTMLDivElement | null>;
}) => (
	<Box
		ref={badgeRef}
		sx={{
			px: 1.5,
			py: 0.75,
			backgroundColor: alpha("#f59e0b", 0.1),
			border: `2px dashed ${alpha("#f59e0b", 0.6)}`,
			borderRadius: 2,
			display: "inline-flex",
			alignItems: "center",
			gap: 0.5,
			marginLeft: 10,
		}}
	>
		<Typography
			variant="caption"
			fontWeight={700}
			sx={{ fontSize: "0.65rem", color: "#d97706", textTransform: "uppercase" }}
		>
			ORPHAN
		</Typography>
	</Box>
);
